import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetState = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_STATE, token);
  return res;
};

export const GetAllRankedMeasureData = async (stateid) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_ALL_RANKED_MEASURE_DATA + stateid,
    token
  );
  return res;
};

export const GetRankedMeasureDataDetail = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_RANKED_MEASURE_DATA_BY_ID + id, token);
  return res;
};

export const AddRankedMeasureData = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_RANKED_MEASURE, payload, token);
  return res;
};

export const DeleteRankedMeasureData = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_RANKED_MEASURE + id, id, token);
  return res;
};
